import React, { useMemo } from 'react';
import { useFormikContext } from 'formik';
import { policyTypes } from '@ourbranch/policy-types';
import { Grid } from '@material-ui/core';
import { observer } from 'mobx-react';

import { FormField } from 'core/components/form';
import { Label } from 'core/components/label';
import { useStore } from 'core/store/store.mobx';
import { autoMultiPolicyDiscountOptionsForOffer, homeMultiPolicyDiscountOptionsForOffer } from 'core/helpers/lookups';
import infoIcon from './assets/info.svg';
import useStyles from './multiline-discount.styles';

const MultilineDiscount = () => {
  const { values, errors, touched, dirty } = useFormikContext();
  const { selectedOption } = values;
  const { offer: store } = useStore();
  const classes = useStyles();

  const isBundle = [policyTypes.ARBundle, policyTypes.HABundle, policyTypes.CABundle, 'AB', 'HB'].includes(
    selectedOption
  );

  const existingMemberLinked = values?.existingCustomer?.id;

  const options =
    values?.selectedOption === policyTypes.Auto
      ? autoMultiPolicyDiscountOptionsForOffer
      : homeMultiPolicyDiscountOptionsForOffer;

  const optionsWithOnlyNoneAvailable = options.map((option) => {
    if (option.id !== 'N') {
      return { ...option, disabled: true };
    }
    return option;
  });

  const isEligible = !isBundle && existingMemberLinked && store.offer?.rejections?.length > 0;

  const formIsDirty =
    dirty &&
    Object.keys(touched).length > 0 &&
    (!Object.keys(touched).includes('forcedMultiPolicyDiscount') ||
      (Object.keys(touched).includes('forcedMultiPolicyDiscount') &&
        values.forcedMultiPolicyDiscount === store.offer.quote.forcedMultiPolicyDiscount));

  const isDisabled = (!errors.multiPolicyDiscount && !isEligible) || formIsDirty;

  const { icon, discountEligibilty, requirement } = useMemo(
    () => ({
      icon: {
        src: infoIcon,
        alt: 'more information button'
      },
      discountEligibilty: isEligible ? (
        <strong>This discount cannot be added alongside other offer changes.</strong>
      ) : (
        'To add a multiline discount, please link the offer to an existing member.'
      ),
      requirement: isEligible
        ? 'This means that you will need to update the offer after adding this discount in order to make additional offer changes. Similarly, you cannot add this discount while there are unsaved offer changes.'
        : ''
    }),
    [isEligible]
  );

  return (
    <Grid className={classes.container}>
      <FormField
        type="select"
        name="forcedMultiPolicyDiscount"
        label="Multiline Discount"
        options={errors.multiPolicyDiscount ? optionsWithOnlyNoneAvailable : options}
        mode="dark"
        disabled={isDisabled}
        fast={false}
        ignoreGlobalDisabledState
      />
      <div className={classes.requirementsContainer}>
        <img src={icon.src} alt={icon.alt} />
        <Label type="body3" className={classes.requirements}>
          {discountEligibilty} {requirement}
        </Label>
      </div>
    </Grid>
  );
};

export default observer(MultilineDiscount);
